import { tWithKeyAttr as t } from "../../../i18nHelper";
import styles from "./rrmModel.module.css";
import { TRRMDisplayEntry } from "../../../services/types/user.types";

function RrmModelPopup({
  score,
  RRMScore,
  scoreList,
  popupTitle,
}: {
  score: number;
  RRMScore: number;
  scoreList: TRRMDisplayEntry[];
  popupTitle?: string;
}) {
  const rrmItem = scoreList?.find((item) => item.rrmseq === RRMScore);
  return (
    <section className={styles.section}>
      <h3 className={"title"}>
        {popupTitle ?? t("RRM_MODEL_POPUP_MAIN_TITLE")}
      </h3>
      {scoreList && scoreList.length > 0 ? (
        <div className={styles.content}>
          <div className={styles.images}>
            <article className={styles.card}>
              <h3 className={styles.card__title}>{t("RRM_MODEL_POPUP_GRRM_TITLE")}</h3>
              <ul className={styles.card__list}>
                <li className={`${styles.card__li} ${styles.card__li_title}`}>
                  <span className={styles.card__text}>{t("RRM_MODEL_POPUP_HEADER_LABEL1")}</span>
                  <span className={styles.card__text}>{t("RRM_MODEL_POPUP_HEADER_LABEL2")}</span>
                  <span className={styles.card__text}>{t("RRM_MODEL_POPUP_HEADER_LABEL3")}</span>
                </li>
                {scoreList.map((item) => (
                  <li
                    className={`${styles.card__li} ${
                      item.rrmseq === RRMScore && styles.card__li_active
                    }`}
                    key={item.id}
                    style={
                      item.rrmseq === RRMScore
                        ? { border: "2px solid #2c2b2b" }
                        : {}
                    }
                  >
                    <div
                      className={styles.card__cell}
                      style={{ backgroundColor: item.color }}
                    >
                      {item.desc || ""}
                    </div>
                    <span className={styles.card__text}>
                      {item.rangeStart != null && item.rangeEnd != null
                        ? `${item.rangeStart} - ${item.rangeEnd}`
                        : ""}
                    </span>
                    <span className={styles.card__text}>{item.title}</span>
                  </li>
                ))}
              </ul>
              {rrmItem && (
                <div className={styles.card__footer}>
                  <p className={styles.card__text}>
                    {t("RRM_MODEL_POPUP_CARD_SCORE_TEXT")} {score}
                  </p>
                  <p className={styles.card__text}>
                    {t("RRM_MODEL_POPUP_CARD_GROUP_TEXT")} {rrmItem.title}
                  </p>
                </div>
              )}
            </article>
          </div>
          <div className={styles.texts}>
            <h3
              className={`${styles.card__title} ${styles.card__title_type_text}`}
            >
              {t("RRM_MODEL_POPUP_ANALYSIS")}
            </h3>
            <p className={styles.text}>{rrmItem?.anliza}</p>
            <h3
              className={`${styles.card__title} ${styles.card__title_type_text}`}
            >
              {t("RRM_MODEL_POPUP_RECOMMENDATIONS")}
            </h3>
            <p className={styles.text}>{rrmItem?.recommendations}</p>
            <h3
              className={`${styles.card__title} ${styles.card__title_type_text}`}
            >
              {t("RRM_MODEL_POPUP_HIGHLIGHTS")}
            </h3>
            <p className={styles.text}>{rrmItem?.highlights}</p>
            <h3
              className={`${styles.card__title} ${styles.card__title_type_text}`}
            >
              {t("RRM_MODEL_POPUP_CONVERSATION")}
            </h3>
            <p className={styles.text}>{rrmItem?.conversation}</p>
          </div>
        </div>
      ) : (
        <p className={"text"}>{t("RRM_MODEL_POPUP_NO_DATA")}</p>
      )}
    </section>
  );
}

export default RrmModelPopup;
